import useAppStore from '@/store/app.store';

import { COMPANY_TYPE } from '@/constants/company-type';
import { ROLES } from '@/constants/roles';

import ConsumerCard from './components/consumer-card/ConsumerCard';
import ProducerCard from './components/producer-card/ProducerCard';
import SettingsCard from './components/settings-card/SettingsCard';

import * as styles from './HomeView.css';

export default function HomeView() {
  const user = useAppStore((state) => state.user);

  const isMoeveAdmin = user?.role === ROLES.MOEVE_ADMIN;
  const isManager = user?.role === ROLES.MANAGER;
  const companyType = user?.companies?.[0]?.company?.companyType?.code;

  const showConsumerCard = isMoeveAdmin || companyType === COMPANY_TYPE.CONSUMER;
  const showProducerCard = isMoeveAdmin || companyType === COMPANY_TYPE.PRODUCER;
  const showSettingsCard = isMoeveAdmin || isManager;
  const visibleCardsCount = [showConsumerCard, showProducerCard, showSettingsCard].filter(Boolean).length;

  if (visibleCardsCount === 3) {
    return (
      <div className={styles.root}>
        <div className={styles.threeCardsContainer}>
          <div className={styles.topCardsContainer}>
            <ConsumerCard />
            <ProducerCard />
          </div>
          <div className={styles.bottomCardsContainer}>
            <SettingsCard variant="left" />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.root}>
      <div className={styles.twoCardsContainer}>
        {showSettingsCard && !showConsumerCard && !showProducerCard && <SettingsCard variant="left" />}
        {showProducerCard && showSettingsCard && <SettingsCard variant="left" />}
        {showConsumerCard && <ConsumerCard />}
        {showProducerCard && <ProducerCard />}
        {showConsumerCard && showSettingsCard && <SettingsCard variant="right" />}
      </div>
    </div>
  );
}
